import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  const { settings } = useSettings();
  const phone = (settings.whatsapp_number || "919000000000").replace(/[^0-9]/g, "");
  const siteName = settings.site_name || "HyderabadTourism.in";
  const text = encodeURIComponent(`Hi! I'd like to enquire about a tour package on ${siteName}`);
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 wa-pulse"
      data-testid="whatsapp-fab"
    >
      <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
        <MessageCircle className="w-7 h-7 text-white" fill="white" stroke="#25D366" />
      </div>
    </a>
  );
}
